import { render, staticRenderFns } from "./ResourceDocuments.vue?vue&type=template&id=18c89fe4&"
import script from "./ResourceDocuments.vue?vue&type=script&lang=js&"
export * from "./ResourceDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports